export const getters = {
  GET_PRJ_SRCH_CONDITION: 'GET_PRJ_SRCH_CONDITION', //* 과제 리스트 검색 조건 가져오기
  GET_PROJECT_EXECUTION_LIST: 'GET_PROJECT_EXECUTION_LIST', //* 과제실행 목록 리스트 가져오기
  GET_PROJECT_EXECUTION_INFO: 'GET_PROJECT_EXECUTION_INFO', //* 과제실행 데이터 가져오기
  GET_PROJECT_STATUS_LIST: 'GET_PROJECT_STATUS_LIST', //* 과제 단계 상태 가져오기
  GET_CHECK_MESSAGES_LIST: 'GET_CHECK_MESSAGES_LIST', //* 단계별 미확인된 메세지 유무 가져오기

  GET_PROJECT_POPUP_INFO: 'GET_PROJECT_POPUP_INFO', //* 최초 과제등록 팝업 INFO 값 가져오기
  GET_PROJECT_DATE_INFO: 'GET_PROJECT_DATE_INFO', //* 과제 기간 설정 팝업 INFO
  GET_PROJECT_CAUSE_INFO: 'GET_PROJECT_CAUSE_INFO', //* 잠재 원인 팝업 INFO 가져오기
  GET_PROJECT_CAUSE_LIST: 'GET_PROJECT_CAUSE_LIST', //* 잠재 원인 팝업 LIST 가져오기
  GET_PROJECT_REPORT_SKIN_INFO: 'GET_PROJECT_REPORT_SKIN_INFO', //* 보고서 스킨설정 팝업 INFO 가져오기
  GET_PROJECT_REPORT_USE_INFO: 'GET_PROJECT_REPORT_USE_INFO', //* 보고서 상세화면 팝업 USE INFO 가져오기
  GET_PROJECT_ATTACH_FILE_INFO: 'GET_PROJECT_ATTACH_FILE_INFO', //* 보고서 첨부파일 팝업 INFO 가져오기
  GET_PROJECT_MESSENGER_INFO: 'GET_PROJECT_MESSENGER_INFO', //* 보고서 메세지 팝업 INFO  가져오기
  GET_PROJECT_MESSENGER_LIST: 'GET_PROJECT_MESSENGER_LIST', //* 과제 메세지 팝업 LIST 가져오기
  GET_PROJECT_SKILL_CONF_INFO: 'GET_PROJECT_SKILL_CONF_INFO', //* 개선스킬 팝업 FILE LIST 가져오기
  GET_PROJECT_SKILL_STEP_INFO: 'GET_PROJECT_SKILL_STEP_INFO', //* 개선스킬 팝업 STEP INFO 가져오기
  GET_PROJECT_KPI_LIST: 'GET_PROJECT_KPI_LIST', //* 연결 KPI LIST가져오기
  GET_ADD_CAUSE_LIST: 'GET_ADD_CAUSE_LIST', //* 잠재원인 팝업에서 추가한 PRJ LIST
  GET_CONN_STG_LIST: 'GET_CONN_STG_LIST', //* 연결 전략과제
  GET_PROJECT_REPORT_INFO: 'GET_PROJECT_REPORT_INFO', //* Report INFO 가져오기

  // TODO POPUP
  GET_VIEWS_PROJECT_REGIST_POP: 'GET_VIEWS_PROJECT_REGIST_POP', //* 과제등록 팝업 ON/OFF 가져오기
  GET_VIEWS_PROJECT_DATE_POP: 'GET_VIEWS_PROJECT_DATE_POP', //* 과제 기간 설정 팝업 ON/OFF 가져오기
  GET_VIEWS_MEASURE_DATE_POP: 'GET_VIEWS_MEASURE_DATE_POP', //* 대첵수립 기간 설정 팝업 ON/OFF 가져오기
  GET_VIEWS_POTENTIAL_CAUSE_POP: 'GET_VIEWS_POTENTIAL_CAUSE_POP', //* 잠재 원인추가 팝업 ON/OFF 가져오기
  GET_VIEWS_REPORT_SKIN_POP: 'GET_VIEWS_REPORT_SKIN_POP', //* 보고서 스킨설정 팝업 ON/OFF 가져오기
  GET_VIEWS_ATTACH_FILE_POP: 'GET_VIEWS_ATTACH_FILE_POP', //* 보고서 첨부파일 팝업 ON/OFF 가져오기
  GET_VIEWS_REPORT_DETAIL_POP: 'GET_VIEWS_REPORT_DETAIL_POP', //* 보고서 상세화면 팝업 ON/OFF 가져오기
  GET_VIEWS_MESSENGER_POP: 'GET_VIEWS_MESSENGER_POP', //* 과제 메신저 팝업 ON/OFF 가져오기
  GET_VIEWS_SKILL_CONF_POP: 'GET_VIEWS_SKILL_CONF_POP', //* 개선스킬 팝업 ON/OFF가져오기
  GET_VIEWS_KPI_LIST_POP: 'GET_VIEWS_KPI_LIST_POP', //* 연결 KPI 팝업 ON/OFF 가져오기
  GET_PROJECT_SKILL_CONF_INFO_POP: 'GET_PROJECT_SKILL_CONF_INFO_POP', //* 개선스킬 팝업 FILE LIST 설정

  //* 연구 / 개발
  GET_PROJECT_BIZ_INFO: 'GET_PROJECT_BIZ_INFO', //* 시장 분석 INFO 가져오기
  GET_PROJECT_CSF_INFO: 'GET_PROJECT_CSF_INFO', //* CSF 도출 INFO 가져오기
  GET_PROJECT_DIRCT_INFO: 'GET_PROJECT_DIRCT_INFO', //* 컨셉수립 INFO 가져오기
  GET_PROJECT_DEV_LIST: 'GET_PROJECT_DEV_LIST', //* 상세계획 LIST 가져오기
  GET_PROJECT_PILOT_LIST: 'GET_PROJECT_PILOT_LIST', //* 현장적용 LIST 가져오기
  GET_PROJECT_RD_EFFECT: 'GET_PROJECT_RD_EFFECT', //* 효과파악 INFO 가져오기

  //* 의사결정
  GET_PROJECT_GRASP_INFO: 'GET_PROJECT_GRASP_INFO', //* 현상파악 INFO 가져오기
  GET_PROJECT_DECISION_LIST: 'GET_PROJECT_DECISION_LIST', //* 결정요인 가져오기
  GET_PROJECT_ALT_LIST: 'GET_PROJECT_ALT_LIST', //* 대안설정 LIST 가져오기
  GET_PROJECT_IMPL_LIST: 'GET_PROJECT_IMPL_LIST', //* 상세계획 LIST가져오기
  GET_PROJECT_DS_EFFECT: 'GET_PROJECT_DS_EFFECT', //* 효과파악 INFO 가져오기

  //* 판매 4단계
  GET_PROJECT_SA_CUST: 'GET_PROJECT_SA_CUST', //* 고객파악 INFO 가져오기
  GET_PROJECT_SA_BIZ: 'GET_PROJECT_SA_BIZ', //* 질문 INFO 가져오기
  GET_PROJECT_SUGGEST_INFO: 'GET_PROJECT_SUGGEST_INFO', //* 제시 INFO 가져오기
  GET_PROJECT_OVER_INFO: 'GET_PROJECT_OVER_INFO', //* 입증 INFO 가져오기
  GET_PROJECT_MON_LIST: 'GET_PROJECT_MON_LIST', //* 결정 LIST 가져오기
  GET_PROJECT_SA_EFFECT: 'GET_PROJECT_SA_EFFECT', //* 효과파악 INFO 가져오기
};

export const actions = {
  // TODO INIT
  INIT_VIEWS_PROJECT_REGIST_POP: 'INIT_VIEWS_PROJECT_REGIST_POP', //* 과제등록 팝업 ON/OFF 설정
  INIT_VIEWS_PROJECT_DATE_POP: 'INIT_VIEWS_PROJECT_DATE_POP', //* 과제 기간 설정 팝업 ON/OFF 설정
  INIT_VIEWS_MEASURE_DATE_POP: 'INIT_VIEWS_MEASURE_DATE_POP', //* 대첵수립 기간 설정 팝업 ON/OFF 설정
  INIT_VIEWS_POTENTIAL_CAUSE_POP: 'INIT_VIEWS_POTENTIAL_CAUSE_POP', //* 잠재 원인추가 팝업 ON/OFF 설정
  INIT_VIEWS_REPORT_SKIN_POP: 'INIT_VIEWS_REPORT_SKIN_POP', //* 보고서 스킨설정 팝업 ON/OFF 설정
  INIT_VIEWS_REPORT_DETAIL_POP: 'INIT_VIEWS_REPORT_DETAIL_POP', //* 보고서 상세화면 팝업 ON/OFF 설정
  INIT_VIEWS_ATTACH_FILE_POP: 'INIT_VIEWS_ATTACH_FILE_POP', //* 보고서 첨부파일 팝업 ON/OFF 설정
  INIT_VIEWS_MESSENGER_POP: 'INIT_VIEWS_MESSENGER_POP', //* 과제 메신저 팝업 ON/OFF 설정
  INIT_VIEWS_SKILL_CONF_POP: 'INIT_VIEWS_SKILL_CONF_POP', //* 개선스킬 팝업 ON/OFF 설정
  INIT_VIEWS_KPI_LIST_POP: 'INIT_VIEWS_KPI_LIST_POP', //* 연결 KPI 팝업 ON/OFF 설정

  INIT_PROJECT_STATUS_LIST: 'INIT_PROJECT_STATUS_LIST', //* 과제 단계 상태 설정
  INIT_PROJECT_CAUSE_INFO: 'INIT_PROJECT_CAUSE_INFO', //* 잠재 원인 POPUP INFO 설정
  INIT_PROJECT_REPORT_SKIN_INFO: 'INIT_PROJECT_REPORT_SKIN_INFO', //* 보고서 스킨설정 팝업 INFO 설정
  INIT_PROJECT_REPORT_USE_INFO: 'INIT_PROJECT_REPORT_USE_INFO', //* 보고서 상세화면 팝업 INFO 설정
  INIT_PROJECT_ATTACH_FILE_INFO: 'INIT_PROJECT_ATTACH_FILE_INFO', //* 보고서 첨부파일 팝업 INFO 설정
  INIT_PROJECT_MESSENGER_INFO: 'INIT_PROJECT_MESSENGER_INFO', //* 보고서 메세지 팝업 INFO 설정
  INIT_PROJECT_SKILL_STEP_INFO: 'INIT_PROJECT_SKILL_STEP_INFO', //* 개선스킬 팝업 STEP INFO 가져오기
  INIT_PRJ_SRCH_CONDITION: 'INIT_PRJ_SRCH_CONDITION', //* 과제 리스트 검색 조건 가져오기
  INIT_PROJECT_EXECUTION_LIST: 'INIT_PROJECT_EXECUTION_LIST', //* 과제실행 목록 리스트  초기화
  INIT_PROJECT_SKILL_CONF_INFO_POP: 'INIT_PROJECT_SKILL_CONF_INFO_POP', //* 개선스킬 팝업 FILE LIST 설정
  INIT_ADD_CAUSE_LIST: 'INIT_ADD_CAUSE_LIST', //* 잠재원인 팝업에서 추가한 PRJ LIST

  // TODO FETCH
  FETCH_CONN_STG_LIST: 'FETCH_CONN_STG_LIST', //* 연결 전략과제
  FETCH_PROJECT_REPORT_USE_INFO: 'FETCH_PROJECT_REPORT_USE_INFO', //* 보고서 상세화면 팝업 INFO 가져오기
  FETCH_PROJECT_EXECUTION_LIST: 'FETCH_PROJECT_EXECUTION_LIST', //* 과제실행 목록 리스트 가져오기
  FETCH_PROJECT_EXECUTION_INFO: 'FETCH_PROJECT_EXECUTION_INFO', //* 과제실행 데이터 가져오기
  FETCH_PROJECT_POPUP_INFO: 'FETCH_PROJECT_POPUP_INFO', //* 최초 과제등록 팝업 INFO
  FETCH_PROJECT_DATE_INFO: 'FETCH_PROJECT_DATE_INFO', //* 과제 기간 설정 팝업 INFO
  FETCH_PROJECT_CAUSE_INFO: 'FETCH_PROJECT_CAUSE_INFO', //* 잠재 원인 INFO 가져오기
  FETCH_PROJECT_CAUSE_LIST: 'FETCH_PROJECT_CAUSE_LIST', //* 잠재 원인 LIST 가져오기
  FETCH_PROJECT_MESSENGER_LIST: 'FETCH_PROJECT_MESSENGER_LIST', //* 과제 메세지 LIST 가져오기
  FETCH_CHECK_MESSAGES_LIST: 'FETCH_CHECK_MESSAGES_LIST', //* 단계별 미확인된 메세지 유무 가져오기
  FETCH_PROJECT_SKILL_CONF_INFO: 'FETCH_PROJECT_SKILL_CONF_INFO', //* 개선스킬 팝업 FILE LIST 설정
  FETCH_PROJECT_KPI_LIST: 'FETCH_PROJECT_KPI_LIST', //* 연결 KPI 팝업 LIST가져오기

  FETCH_PROJECT_REPORT_INFO: 'FETCH_PROJECT_REPORT_INFO', //* Report INFO 가져오기
  //* 연구 / 개발
  FETCH_PROJECT_BIZ_INFO: 'FETCH_PROJECT_BIZ_INFO', //* 시장 분석 INFO 가져오기
  FETCH_PROJECT_CSF_INFO: 'FETCH_PROJECT_CSF_INFO', //* CSF 도출 INFO 가져오기
  FETCH_PROJECT_DIRCT_INFO: 'FETCH_PROJECT_DIRCT_INFO', //* 컨셉수립 INFO 가져오기
  FETCH_PROJECT_DEV_LIST: 'FETCH_PROJECT_DEV_LIST', //* 상세계획 INFO 가져오기
  FETCH_PROJECT_PILOT_LIST: 'FETCH_PROJECT_PILOT_LIST', //* 현장적용 LIST 가져오기
  FETCH_PROJECT_RD_EFFECT: 'FETCH_PROJECT_RD_EFFECT', //* 효과파악 INFO 가져오기

  //* 의사결정
  FETCH_PROJECT_GRASP_INFO: 'FETCH_PROJECT_GRASP_INFO', //* 현상파악 INFO 가져오기
  FETCH_PROJECT_DECISION_LIST: 'FETCH_PROJECT_DECISION_LIST', //* 결정요인 가져오기
  FETCH_PROJECT_ALT_LIST: 'FETCH_PROJECT_ALT_LIST', //* 대안설정 LIST 가져오기
  FETCH_PROJECT_IMPL_LIST: 'FETCH_PROJECT_IMPL_LIST', //* 상세계획 LIST 가져오기
  FETCH_PROJECT_RISK_LIST: 'FETCH_PROJECT_RISK_LIST', //* RISK관리 LIST 가져오기
  FETCH_PROJECT_DS_EFFECT: 'FETCH_PROJECT_DS_EFFECT', //* 효과파악 INFO 가져오기

  //* 판매 4단계
  FETCH_PROJECT_SA_CUST: 'FETCH_PROJECT_SA_CUST', //* 고객파악 INFO 가져오기
  FETCH_PROJECT_SA_BIZ: 'FETCH_PROJECT_SA_BIZ', //* 질문 INFO 가져오기
  FETCH_PROJECT_SUGGEST_INFO: 'FETCH_PROJECT_SUGGEST_INFO', //* 제시 INFO 가져오기
  FETCH_PROJECT_OVER_INFO: 'FETCH_PROJECT_OVER_INFO', //* 입증 INFO 가져오기
  FETCH_PROJECT_MON_LIST: 'FETCH_PROJECT_MON_LIST', //* 결정 LIST 가져오기
  FETCH_PROJECT_SA_EFFECT: 'FETCH_PROJECT_SA_EFFECT', //* 효과파악 INFO 가져오기

  // TODO INSERT
  INSERT_PROJECT_MESSAGES: 'INSERT_PROJECT_MESSAGES', //* 과제 메세지 전송

  // TODO UPDATE
  UPDATE_PROJECT_EXECUTION: 'UPDATE_PROJECT_EXECUTION', //* 과제최초 & 기본개요저장
  UPDATE_PROJECT_OVERVIEW: 'UPDATE_PROJECT_OVERVIEW', //* 과제 추진개요 저장
  UPDATE_PROJECT_RESOURCE: 'UPDATE_PROJECT_RESOURCE', //* 과제 소요자원 저장
  UPDATE_PROJECT_DATEINFO: 'UPDATE_PROJECT_DATEINFO', //* 과제 기간 POPUP 저장
  UPDATE_PROJECT_EXREVIEW: 'UPDATE_PROJECT_EXREVIEW', //* 과제 실행검토 저장
  UPDATE_PROJECT_GRASP: 'UPDATE_PROJECT_GRASP', //* 과제 현상파악 저장
  UPDATE_PROJECT_CAUSE: 'UPDATE_PROJECT_CAUSE', //* 과제 잠재원인 저장
  DELETE_PROJECT_CAUSE: 'DELETE_PROJECT_CAUSE', //* 과제 잠재원인 삭제
  UPDATE_PROJECT_MEASURE: 'UPDATE_PROJECT_MEASURE', //* 과제 대책수립 저장
  UPDATE_PROJECT_PLAN: 'UPDATE_PROJECT_PLAN', //* 과제 상세계획
  UPDATE_PROJECT_MANAGER_PLAN: 'UPDATE_PROJECT_MANAGER_PLAN', //* 대책수립 대단계 수행검토
  UPDATE_PROJECT_REALIZE: 'UPDATE_PROJECT_REALIZE', //* 과제 현장파악 저장
  UPDATE_PROJECT_EFFECT: 'UPDATE_PROJECT_EFFECT', //* 과제  효과파악 저장
  UPDATE_PROJECT_REPORT: 'UPDATE_PROJECT_REPORT', //*  과제 종료보고(보고서) 저장
  UPDATE_PROJECT_FINISH: 'UPDATE_PROJECT_FINISH', //* 과제완료
  UPDATE_PROJECT_BEST: 'UPDATE_PROJECT_BEST', //* 우수 과제 선정
  UPDATE_PROJECT_MESSENGER: 'UPDATE_PROJECT_MESSENGER', //* 메세지 읽음상태 업데이트

  //* 연구 / 개발
  UPDATE_PROJECT_BIZ_INFO: 'UPDATE_PROJECT_BIZ_INFO', //* 시장 분석 INFO 저장
  UPDATE_PROJECT_CSF_INFO: 'UPDATE_PROJECT_CSF_INFO', //* CSF 도출 INFO 저장
  UPDATE_PROJECT_DIRCT_INFO: 'UPDATE_PROJECT_DIRCT_INFO', //* 컨셉수립 INFO 저장
  UPDATE_PROJECT_DEV_LIST: 'UPDATE_PROJECT_DEV_LIST', //* 상세계획 INFO 저장
  UPDATE_PROJECT_PILOT_LIST: 'UPDATE_PROJECT_PILOT_LIST', //* 현장적용 LIST 저장
  UPDATE_PROJECT_RD_EFFECT: 'UPDATE_PROJECT_RD_EFFECT', //* 효과파악 INFO 저장

  //* 의사결정
  UPDATE_PROJECT_GRASP_INFO: 'UPDATE_PROJECT_GRASP_INFO', //* 현상파악 저장
  UPDATE_PROJECT_DECISION_LIST: 'UPDATE_PROJECT_DECISION_LIST', //* 결정요인 저장
  UPDATE_PROJECT_ALT_LIST: 'UPDATE_PROJECT_ALT_LIST', //* 대안설정 LIST 저장
  UPDATE_PROJECT_IMPL_LIST: 'UPDATE_PROJECT_IMPL_LIST', //* 상세계획 LIST 저장
  UPDATE_PROJECT_RISK_LIST: 'UPDATE_PROJECT_RISK_LIST', //* RISK관리 LIST 저장
  UPDATE_PROJECT_DS_EFFECT: 'UPDATE_PROJECT_DS_EFFECT', //* 효과파악 INFO 저장

  //* 판매 4단계
  UPDATE_PROJECT_SA_CUST: 'UPDATE_PROJECT_SA_CUST', //* 고객파악 INFO 저장
  UPDATE_PROJECT_SA_BIZ: 'UPDATE_PROJECT_SA_BIZ', //* 질문 INFO 저장
  UPDATE_PROJECT_SUGGEST_INFO: 'UPDATE_PROJECT_SUGGEST_INFO', //* 제시 INFO 저장
  UPDATE_PROJECT_OVER_INFO: 'UPDATE_PROJECT_OVER_INFO', //* 입증 INFO 저장
  UPDATE_PROJECT_MON_LIST: 'UPDATE_PROJECT_MON_LIST', //* 결정 LIST 저장
  UPDATE_PROJECT_SA_EFFECT: 'UPDATE_PROJECT_SA_EFFECT', //* 효과파악 INFO 저장
};

export const mutations = {
  // TODO SET
  SET_PRJ_SRCH_CONDITION: 'SET_PRJ_SRCH_CONDITION', //* 과제 리스트 검색 조건 세팅
  SET_PROJECT_EXECUTION_LIST: 'SET_PROJECT_EXECUTION_LIST', //* 과제실행 목록 데이터 세팅
  SET_PROJECT_EXECUTION_INFO: 'SET_PROJECT_EXECUTION_INFO', //* 과제실행 데이터 세팅
  SET_PROJECT_STATUS_LIST: 'SET_PROJECT_STATUS_LIST', //* 과제 단계 상태 설정
  SET_CHECK_MESSAGES_LIST: 'SET_CHECK_MESSAGES_LIST', //* 단계별 미확인된 메세지 유무 설정
  SET_CONN_STG_LIST: 'SET_CONN_STG_LIST', //* 연결 전략과제

  SET_PROJECT_POPUP_INFO: 'SET_PROJECT_POPUP_INFO', //* 최초 과제등록 팝업 INFO 값 세팅
  SET_PROJECT_DATE_INFO: 'SET_PROJECT_DATE_INFO', //* 과제 기간 설정 팝업 INFO 값 세팅
  SET_PROJECT_CAUSE_INFO: 'SET_PROJECT_CAUSE_INFO', //* 잠재 원인 팝업 INFO 값 세팅
  SET_PROJECT_CAUSE_LIST: 'SET_PROJECT_CAUSE_LIST', //* 잠재 원인 팝업 LIST 값 세팅
  SET_PROJECT_REPORT_SKIN_INFO: 'SET_PROJECT_REPORT_SKIN_INFO', //* 보고서 스킨설정 팝업 INFO 값 세팅
  SET_PROJECT_ATTACH_FILE_INFO: 'SET_PROJECT_ATTACH_FILE_INFO', //* 보고서 첨부파일 팝업 INFO 가져오기
  SET_PROJECT_MESSENGER_INFO: 'SET_PROJECT_MESSENGER_INFO', //* 보고서 메세지 팝업 INFO 설정
  SET_PROJECT_MESSENGER_LIST: 'SET_PROJECT_MESSENGER_LIST', //* 과제 메세지 LIST 설정
  SET_PROJECT_SKILL_CONF_INFO: 'SET_PROJECT_SKILL_CONF_INFO', //* 개선스킬 FILE LIST 설정
  SET_PROJECT_SKILL_CONF_INFO_POP: 'SET_PROJECT_SKILL_CONF_INFO_POP', //* 개선스킬 팝업 FILE LIST 설정
  SET_PROJECT_SKILL_STEP_INFO: 'SET_PROJECT_SKILL_STEP_INFO', //* 개선스킬 팝업 STEP INFO 가져오기
  SET_PROJECT_KPI_LIST: 'SET_PROJECT_KPI_LIST', //* 연결 KPI LIST가져오기
  SET_ADD_CAUSE_LIST: 'SET_ADD_CAUSE_LIST', //* 잠재원인 팝업에서 추가한 PRJ LIST

  SET_VIEWS_PROJECT_REGIST_POP: 'SET_VIEWS_PROJECT_REGIST_POP', //* 과제등록 팝업 ON/OFF 설정
  SET_VIEWS_PROJECT_DATE_POP: 'SET_VIEWS_PROJECT_DATE_POP', //* 과제 기간 설정 팝업 ON/OFF 설정
  SET_VIEWS_MEASURE_DATE_POP: 'SET_VIEWS_MEASURE_DATE_POP', //* 대첵수립 기간 설정 팝업 ON/OFF 설정
  SET_VIEWS_POTENTIAL_CAUSE_POP: 'SET_VIEWS_POTENTIAL_CAUSE_POP', //* 잠재 원인추가 팝업 ON/OFF 설정
  SET_VIEWS_REPORT_SKIN_POP: 'SET_VIEWS_REPORT_SKIN_POP', //* 보고서 스킨설정 팝업 ON/OFF 설정
  SET_PROJECT_REPORT_USE_INFO: 'SET_PROJECT_REPORT_USE_INFO', //* 보고서 상세화면 팝업 INFO 설정
  SET_VIEWS_REPORT_DETAIL_POP: 'SET_VIEWS_REPORT_DETAIL_POP', //* 보고서 상세화면 팝업 ON/OFF 설정
  SET_VIEWS_ATTACH_FILE_POP: 'SET_VIEWS_ATTACH_FILE_POP', //* 보고서 첨부파일 팝업 ON/OFF 설정
  SET_VIEWS_MESSENGER_POP: 'SET_VIEWS_MESSENGER_POP', //* 과제 메신저 팝업 ON/OFF 설정
  SET_VIEWS_SKILL_CONF_POP: 'SET_VIEWS_SKILL_CONF_POP', //* 개선스킬 팝업 ON/OFF 설정
  SET_VIEWS_KPI_LIST_POP: 'SET_VIEWS_KPI_LIST_POP', //* 연결 KPI  팝업 ON/OFF설정
  SET_PROJECT_REPORT_INFO: 'SET_PROJECT_REPORT_INFO', //* Report INFO 설정
  //* 연구 / 개발
  SET_PROJECT_BIZ_INFO: 'SET_PROJECT_BIZ_INFO', //* 시장 분석 INFO 설정
  SET_PROJECT_CSF_INFO: 'SET_PROJECT_CSF_INFO', //* CSF 도출 INFO 설정
  SET_PROJECT_DIRCT_INFO: 'SET_PROJECT_DIRCT_INFO', //* 컨셉수립 INFO 설정
  SET_PROJECT_DEV_LIST: 'SET_PROJECT_DEV_LIST', //* 상세계획 LIST 설정
  SET_PROJECT_PILOT_LIST: 'SET_PROJECT_PILOT_LIST', //* 현장적용  LIST 설정
  SET_PROJECT_RD_EFFECT: 'SET_PROJECT_RD_EFFECT', //* 효과파악 INFO 설정

  //* 의사결정
  SET_PROJECT_GRASP_INFO: 'SET_PROJECT_GRASP_INFO', //* 현상파악 INFO 설정
  SET_PROJECT_DECISION_LIST: 'SET_PROJECT_DECISION_LIST', //* 결정요인 LIST 설정
  SET_PROJECT_ALT_LIST: 'SET_PROJECT_ALT_LIST', //* 대안설정 LIST 설정
  SET_PROJECT_IMPL_LIST: 'SET_PROJECT_IMPL_LIST', //* 상세계획 LIST 설정
  SET_PROJECT_RISK_LIST: 'SET_PROJECT_RISK_LIST', //* RISK관리 LIST 설정
  SET_PROJECT_DS_EFFECT: 'SET_PROJECT_DS_EFFECT', //* 효과파악 INFO 설정

  //* 판매 4단계
  SET_PROJECT_SA_CUST: 'SET_PROJECT_SA_CUST', //* 고객파악 INFO 설정
  SET_PROJECT_SA_BIZ: 'SET_PROJECT_SA_BIZ', //* 질문 INFO 설정
  SET_PROJECT_SUGGEST_INFO: 'SET_PROJECT_SUGGEST_INFO', //* 제시 INFO 설정
  SET_PROJECT_OVER_INFO: 'SET_PROJECT_OVER_INFO', //* 입증 INFO 설정
  SET_PROJECT_MON_LIST: 'SET_PROJECT_MON_LIST', //* 결정 LIST 설정
  SET_PROJECT_SA_EFFECT: 'SET_PROJECT_SA_EFFECT', //* 효과파악 INFO 설정
};

//* ROOT ACTIONS CONSTANT
export const rootActions = {
  ...Object.entries(actions).reduce((acc, cur) => {
    acc[cur[0]] = `specializedTasks/${cur[1]}`;
    return acc;
  }, {}),
};

//* ROOT MUTATIONS CONSTANT
export const rootMutations = {
  ...Object.entries(mutations).reduce((acc, cur) => {
    acc[cur[0]] = `specializedTasks/${cur[1]}`;
    return acc;
  }, {}),
};
